interface QuoteTimer {
  readonly name: string;
  readonly value: 'no-expire';
}

export const TIMER_OPTIONS: QuoteTimer[] = [
  { name: 'Good Till Canceled', value: 'no-expire' },
];
